export class Cache {
    // eslint-disable-next-line no-useless-constructor, no-empty-function
    constructor(ttl) {
        this.ttl = ttl;
        this.cache = null;
    }
    get() {
        if (!this.cache) {
            return null;
        }
        if (Date.now() - this.cache.timestamp >= this.ttl) {
            this.cache = null;
            return null;
        }
        return this.cache.data;
    }
    set(data) {
        this.cache = {
            data,
            timestamp: Date.now(),
        };
    }
}
